export default {
	Ready: 'Ready',
	Active: 'Active',
	Deactive: 'Deactive'
}


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/dashboard/PresetStatus.js